export enum Title {
  EMPTY = 'EMPTY',
}

export enum Salutation {
  EMPTY = 'EMPTY',
  MR = 'MR',
  MS = 'MS',
}
